import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Hero } from "./components/sections/Hero";
import { About } from "./components/sections/About";
import { Services } from "./components/sections/Services";
import { Trust } from "./components/sections/Trust";
import { Contact } from "./components/sections/Contact";
import { ChatWidget } from "./components/ChatWidget";
import { isShabbatNow } from "./utils/shabbatCheck";
import ShabbatPage from "./pages/ShabbatPage";

import {
  AccessibilityProvider,
  AccessibilityPanel,
  FocusManager,
  KeyboardManager,
  ReducedMotionManager,
  AriaLiveRegion,
} from "./accessibility";
import { AccessibilityStatement } from "./pages/legal/AccessibilityStatement";
import { Terms } from "./pages/legal/Terms";
import { PrivacyPolicy } from "./pages/legal/PrivacyPolicy";
import { useEffect, useState } from "react";

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isShabbat, setIsShabbat] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    isShabbatNow().then((result) => {
      setIsShabbat(result);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<{ open: boolean }>;
      setMobileMenuOpen(!!ce.detail?.open);
    };

    window.addEventListener("mobile-menu-state", handler);
    return () => window.removeEventListener("mobile-menu-state", handler);
  }, []);

  if (loading) return null;

  if (isShabbat) {
    return <ShabbatPage />;
  }

  return (
    <AccessibilityProvider>
      <BrowserRouter>
        <ReducedMotionManager />
        <FocusManager />
        <KeyboardManager />
        <AriaLiveRegion />

        {/* ✅ גלובלי לכל האתר */}
        <div className={mobileMenuOpen ? "hidden" : ""}>
          <AccessibilityPanel />
          <ChatWidget />
        </div>

        <Routes>
          {/* Home */}
          <Route
            path="/"
            element={
              <>
                {/* <Scene /> */}
                <Layout>
                  <Hero />
                  <About />
                  <Services />
                  <Trust />
                  <Contact />
                </Layout>
              </>
            }
          />

          {/* Accessibility Page */}
          <Route path="/accessibility" element={<AccessibilityStatement />} />

          {/* Legal Pages */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </AccessibilityProvider>
  );
}

export default App;
